import { render, staticRenderFns } from "./AddFeeitem.vue?vue&type=template&id=0192eefb"
import script from "./AddFeeitem.vue?vue&type=script&lang=js"
export * from "./AddFeeitem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports